<h2 mat-dialog-title class='text-lg'>Export Subtitles</h2>
<mat-dialog-content>
    <form [formGroup]='viewModel.form'>
        <div class='space-y-md md-sm mt-md'>
            <div class='form-group'>
                <app-dropdown
                    label='Type'
                    formControlName='type'
                    [options]='types'
                    [(ngModel)]='type'></app-dropdown>
            </div>
            <div class='form-group'>
                <app-dropdown
                    label='Language'
                    formControlName='language'
                    [options]='languages'
                    [(ngModel)]='language'></app-dropdown>
            </div>
            <div class='form-group'>
                <label>Timing (sec)</label>
                <mat-form-field class='w-full'>
                  <input
                    matInput
                    type='number'
                    formControlName='timing'
                    [(ngModel)]='timing'
                  />
                </mat-form-field>
            </div>
            <div class='form-group' *ngIf='type.startsWith("srt")'>
                <label>Max Line Length</label>
                <mat-form-field class='w-full'>
                  <input
                    matInput
                    type='number'
                    formControlName='lineLength'
                    [(ngModel)]='lineLength'
                  />
                </mat-form-field>
            </div>       
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex justify-end ml-auto'>
        <button class='btn btn-secondary mr-sm' [mat-dialog-close]='true'>Cancel</button>
        <button class='btn btn-primary' (click)='exportSubtitles()'>Export</button>
    </div>
</mat-dialog-actions>